module.exports = __webpack_public_path__ + "img/outlet-setting.e22c43eb.png";